module.exports = __webpack_public_path__ + "img/2.e22182a3.jpg";